import React, { createContext } from 'react';

export const ScrollContext = createContext({
  isScrolling: true
});
